/**
 * KAN-713: справочник прокси Telegram-аккаунтов.
 *
 *   GET    /api/v1/telegram-proxies/             - прокси организации с последней проверкой
 *   POST   /api/v1/telegram-proxies/             - поля или proxy_string
 *   PATCH  /api/v1/telegram-proxies/{id}/        - пустой password оставляет старый
 *   DELETE /api/v1/telegram-proxies/{id}/
 *   POST   /api/v1/telegram-proxies/{id}/check/  - проверка сохранённого (пишется в last_check)
 *   POST   /api/v1/telegram-proxies/check/       - проверка полей без сохранения
 */
import apiClient from './client';
import type {
  ProxyCheckResult,
  TelegramProxy,
  TelegramProxyBody,
} from '@/types/telegramProxy';

const BASE = '/api/v1/telegram-proxies/';

export const telegramProxiesApi = {
  list: async (): Promise<TelegramProxy[]> => (await apiClient.get(BASE)).data,
  create: async (data: TelegramProxyBody): Promise<TelegramProxy> =>
    (await apiClient.post(BASE, data)).data,
  update: async (id: number, data: TelegramProxyBody): Promise<TelegramProxy> =>
    (await apiClient.patch(`${BASE}${id}/`, data)).data,
  remove: async (id: number): Promise<void> => {
    await apiClient.delete(`${BASE}${id}/`);
  },
  checkSaved: async (id: number): Promise<ProxyCheckResult> =>
    (await apiClient.post(`${BASE}${id}/check/`)).data,
  checkDraft: async (data: TelegramProxyBody): Promise<ProxyCheckResult> =>
    (await apiClient.post(`${BASE}check/`, data)).data,
};
